import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../assets/styles/kepulangan.css';
import ButtonUngu from '../assets/images/Button ungu.png';
import ChevronLeft from '../assets/images/Chevron-Left.png';

const Kepulangan = () => {
  const navigate = useNavigate();
  const { day } = useParams();

  return (
    <div className="kepulangan-page">
      <div className="header">
        <img src={ChevronLeft} alt="Back" className="back-arrow" onClick={() => navigate(`/menu/${day}`)} />
        <h1 className="title">Kepulangan</h1>
      </div>
      <div className="upload-container">
        <h2>Upload Foto</h2>
        <form>
          <label htmlFor="file-upload" className="file-label">
            Pilih Foto:
            <input id="file-upload" type="file" />
          </label>
          <button type="submit" className="upload-button">
            <img src={ButtonUngu} alt="Upload Foto" />
            <span>Upload Foto</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Kepulangan;
